/**
 * AWS Cognito sign-in step constants (Amplify v6)
 * These are the possible values for signInResult.nextStep.signInStep
 */
export const SIGN_IN_STEP = {
  /** User needs to set a new password (e.g., invited user with temporary password) */
  CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED:
    'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',
  /** User needs to enter TOTP code from authenticator app */
  CONFIRM_SIGN_IN_WITH_TOTP_CODE: 'CONFIRM_SIGN_IN_WITH_TOTP_CODE',
  /** User needs to enter SMS code (used during account recovery) */
  CONFIRM_SIGN_IN_WITH_SMS_CODE: 'CONFIRM_SIGN_IN_WITH_SMS_CODE',
  /** User needs to set up TOTP for MFA */
  CONTINUE_SIGN_IN_WITH_TOTP_SETUP: 'CONTINUE_SIGN_IN_WITH_TOTP_SETUP',
  /** Lazy migration fallback: user has multiple MFA methods enabled and must pick one */
  CONTINUE_SIGN_IN_WITH_MFA_SELECTION: 'CONTINUE_SIGN_IN_WITH_MFA_SELECTION',
  /** User needs to confirm sign up (email verification) */
  CONFIRM_SIGN_UP: 'CONFIRM_SIGN_UP',
  /** Sign-in completed successfully */
  DONE: 'DONE',
} as const;

export type SignInStep = (typeof SIGN_IN_STEP)[keyof typeof SIGN_IN_STEP];

/**
 * If the response from the updateUserAttribute API contains this string,
 * it means that the user needs to confirm the attribute with a code.
 *
 * If it doesn't contain it for phone_number, we need to send a verification code.
 */
export const CONFIRM_ATTRIBUTE_WITH_CODE = 'CONFIRM_ATTRIBUTE_WITH_CODE';
